"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connect = void 0;
const web3_js_1 = require("@solana/web3.js");
const connections = {};
async function connect(rpc, transactionTimeout = 1000 * 30, commitment = 'confirmed') {
    const id = `c_${rpc}_${transactionTimeout}_${commitment}`;
    if (!connections.hasOwnProperty(id)) {
        try {
            const connection = new web3_js_1.Connection(rpc, {
                commitment: 'confirmed',
                confirmTransactionInitialTimeout: transactionTimeout,
            });
            const firstAvailableBlock = await connection.getFirstAvailableBlock();
            connections[id] = connection;
        }
        catch (err) {
            if (err === null || err === void 0 ? void 0 : err.message)
                throw new Error(err.message);
            throw new Error("Unable to establish connection!");
        }
    }
    return connections[id];
}
exports.connect = connect;
